var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.finishedLoading && _vm.bookableItem
    ? _c(
        "v-container",
        { staticClass: "pa-0", attrs: { fluid: "" } },
        [
          _c(
            "ApplicationWrapper",
            {
              attrs: {
                headerBackTooltip:
                  _vm.itemType === _vm.TYPE_COURSES
                    ? _vm.$t("overview.details_header_backToCourseDetails")
                    : _vm.$t("overview.details_header_backToHallMeetings"),
                headerImage: _vm.bookableItem.image,
                headerTitle: _vm.bookableItem.title,
              },
              on: { onButtonBackClick: _vm.handleBackButtonClick },
            },
            [
              this.bookableItem.price > 0.0
                ? _c(
                    "template",
                    { slot: "details" },
                    [
                      _c(
                        "v-dialog",
                        {
                          attrs: {
                            width: "300px",
                            persistent: "",
                            absolute: "absolute",
                          },
                          model: {
                            value: _vm.confirmDirectPayment,
                            callback: function ($$v) {
                              _vm.confirmDirectPayment = $$v
                            },
                            expression: "confirmDirectPayment",
                          },
                        },
                        [
                          _c(
                            "v-card",
                            [
                              _c("v-card-title", { staticClass: "text-h5" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t(
                                        "payment.info_direct_payment_title"
                                      )
                                    ) +
                                    " "
                                ),
                              ]),
                              _c("v-card-text", [
                                _c("div", {
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.$t("payment.info_direct_payment")
                                    ),
                                  },
                                }),
                              ]),
                              _c(
                                "v-card-actions",
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      on: {
                                        click:
                                          _vm.handleDirectPaymentDialogDecline,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "payment.info_direct_payment_btn_no"
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                  _c("v-spacer"),
                                  _c(
                                    "v-btn",
                                    {
                                      on: {
                                        click: function ($event) {
                                          _vm.hasAcceptedDirectPaymentDialog = true
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "payment.info_direct_payment_btn_continue"
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-list",
                        {
                          staticClass: "nomargin-firstchild nomargin-lastchild",
                          attrs: { "two-line": "" },
                        },
                        [
                          _c("Detail", {
                            staticClass: "text-center",
                            attrs: {
                              title:
                                "Bitte wählen Sie eine Zahlungsmethode aus.",
                              subTitle: "Es können Gebühren anfallen.",
                            },
                          }),
                          _vm._l(
                            _vm.paymentOptions.filter(
                              (paymentOption) =>
                                paymentOption.Name != _vm.PAYMENTOPTION_KLARNA
                            ),
                            function (paymentOption, index) {
                              return _c(
                                "Detail",
                                {
                                  key: "paymentOption" + index,
                                  attrs: {
                                    "append-icon":
                                      _vm.paymentOptions.length > 1
                                        ? "someValue"
                                        : "",
                                    prependIcon: "mdi-cash-multiple",
                                  },
                                },
                                [
                                  _c(
                                    "template",
                                    { slot: "content-override" },
                                    [
                                      _c(
                                        "v-list-item-content",
                                        {
                                          staticClass:
                                            "align-center row-height elevation-2 rounded",
                                          staticStyle: {
                                            overflow: "hidden",
                                            position: "relative",
                                          },
                                        },
                                        [
                                          _c("v-overlay", {
                                            attrs: {
                                              absolute: "absolute",
                                              color: _vm.loading
                                                .renderingPayPalButton
                                                ? "grey"
                                                : "grey lighten-2",
                                              value:
                                                _vm.selectedPaymentOption !==
                                                  paymentOption.Name ||
                                                _vm.loading
                                                  .renderingPayPalButton,
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.handlePaymentSelection(
                                                  paymentOption.Name
                                                )
                                              },
                                            },
                                          }),
                                          _c(
                                            "v-row",
                                            {
                                              staticClass: "px-2",
                                              staticStyle: {
                                                "text-wrap": "balance",
                                              },
                                              attrs: {
                                                align: "start",
                                                justify: "center",
                                              },
                                            },
                                            [
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "4" } },
                                                [
                                                  paymentOption.Name ==
                                                  _vm.PAYMENTOPTION_DEFAULT
                                                    ? _c("p", [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "payment.paymentOptionInvoice"
                                                              )
                                                            ) +
                                                            " "
                                                        ),
                                                      ])
                                                    : paymentOption.Name ==
                                                      _vm.PAYMENTOPTION_PAYPAL
                                                    ? _c("p", [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "payment.paymentOptionPaypal"
                                                              )
                                                            ) +
                                                            " "
                                                        ),
                                                      ])
                                                    : _vm._e(),
                                                ]
                                              ),
                                              _c("v-spacer"),
                                              !_vm.isNoWs(
                                                _vm.getFeeString(
                                                  paymentOption.Name
                                                )
                                              )
                                                ? _c(
                                                    "v-col",
                                                    { attrs: { cols: "3" } },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "payment.fee"
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                      _c("br"),
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.getFeeString(
                                                              paymentOption.Name
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  )
                                                : _c(
                                                    "v-col",
                                                    { attrs: { cols: "3" } },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "payment.fee"
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                      _c("br"),
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "common.label_none"
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "4" } },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "payment.final_amount"
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                  _c("br"),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.getFinalAmountString(
                                                          paymentOption.Name
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "template",
                                    { slot: "actionarea" },
                                    [
                                      _c(
                                        "v-radio-group",
                                        {
                                          attrs: {
                                            value: _vm.selectedPaymentOption,
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.handlePaymentSelection(
                                                paymentOption.Name
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("v-radio", {
                                            attrs: {
                                              value: paymentOption.Name,
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                2
                              )
                            }
                          ),
                        ],
                        2
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              this.bookableItem.price == 0.0
                ? _c(
                    "template",
                    { slot: "details" },
                    [
                      _c(
                        "v-container",
                        { staticStyle: { height: "400px" } },
                        [
                          _c(
                            "v-row",
                            {
                              staticClass: "fill-height",
                              attrs: {
                                "align-content": "center",
                                justify: "center",
                              },
                            },
                            [
                              _c(
                                "v-col",
                                {
                                  staticClass: "text-subtitle-1 text-center",
                                  attrs: { cols: "12" },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.$t("payment.booking_free")) +
                                      " "
                                  ),
                                ]
                              ),
                              _c(
                                "v-col",
                                { attrs: { cols: "6" } },
                                [
                                  _c("v-progress-linear", {
                                    attrs: {
                                      color: "primary",
                                      indeterminate: "",
                                      rounded: "",
                                      height: "6",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              this.bookableItem.price > 0.0
                ? _c(
                    "template",
                    { slot: "actionbuttons" },
                    [
                      _vm.selectedPaymentOption == _vm.PAYMENTOPTION_DEFAULT
                        ? _c(
                            "v-btn",
                            {
                              attrs: {
                                loading: _vm.loading.invoicePaymentButton,
                                color: "primary",
                              },
                              on: { click: _vm.handleBookViaInvoice },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t("payment.paymentOptionInvoice")
                                  ) +
                                  " "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm.selectedPaymentOption == _vm.PAYMENTOPTION_PAYPAL
                        ? _c("div", { attrs: { id: _vm.PAYPAL_BUTTON_ID } })
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            2
          ),
        ],
        1
      )
    : _c(
        "v-container",
        { staticStyle: { height: "400px" } },
        [
          _c(
            "v-row",
            {
              staticClass: "fill-height",
              attrs: { "align-content": "center", justify: "center" },
            },
            [
              _c(
                "v-col",
                {
                  staticClass: "text-subtitle-1 text-center",
                  attrs: { cols: "12" },
                },
                [_vm._v(" " + _vm._s(_vm.$t("payment.loading_Methods")) + " ")]
              ),
              _c(
                "v-col",
                { attrs: { cols: "6" } },
                [
                  _c("v-progress-linear", {
                    attrs: {
                      color: "primary",
                      indeterminate: "",
                      rounded: "",
                      height: "6",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }